import React, { useEffect, useRef } from 'react';

const StaticBackground: React.FC = () => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Set canvas size
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      
      // Clear canvas
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Generate fixed data points
      const dataPoints: { x: number; y: number; size: number; color: string }[] = [];
      for (let i = 0; i < 30; i++) {
        dataPoints.push({
          x: Math.random() * canvas.width,
          y: Math.random() * canvas.height,
          size: Math.random() * 3 + 1,
          color: `rgba(59, 130, 246, ${Math.random() * 0.5 + 0.2})`
        });
      }

      // Generate fixed data lines
      const dataLines: { startX: number; startY: number; endX: number; endY: number; color: string; opacity: number }[] = [];
      for (let i = 0; i < 20; i++) {
        dataLines.push({
          startX: Math.random() * canvas.width,
          startY: Math.random() * canvas.height,
          endX: Math.random() * canvas.width,
          endY: Math.random() * canvas.height,
          color: `rgba(59, 130, 246, ${Math.random() * 0.3 + 0.1})`,
          opacity: Math.random() * 0.2 + 0.05
        });
      }

      // Draw static data lines
      dataLines.forEach(line => {
        ctx.beginPath();
        ctx.moveTo(line.startX, line.startY);
        ctx.lineTo(line.endX, line.endY);
        ctx.strokeStyle = line.color;
        ctx.lineWidth = 1;
        ctx.stroke();
      });

      // Draw static data points
      dataPoints.forEach(point => {
        ctx.beginPath();
        ctx.arc(point.x, point.y, point.size, 0, Math.PI * 2);
        ctx.fillStyle = point.color;
        ctx.fill();
      });
    };

    // Add resize listener to redraw on window resize
    window.addEventListener('resize', resize);
    resize();

    // Cleanup
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas 
      ref={canvasRef} 
      className="fixed top-0 left-0 w-full h-full -z-10"
    />
  );
};

export default StaticBackground;